import ApiFetcher2 from 'static/three-oh/src/modules/apis/ApiFetcher2';

class CollectionsApi {
  static get(params) {
    return ApiFetcher2.get('collection', {params});
  }
}

export default CollectionsApi;
